import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: 0,
    },
    card: {
      minWidth: 210,
      marginTop: MIDDLE_MARGIN,
      marinBottom: MIDDLE_MARGIN,
      background: colorsPalette.violetAnalyticsCard,
      border: `3px solid ${colorsPalette.blue}`,
      borderRadius: 5,
      boxShadow: `0px 3px 6px ${fade(colorsPalette.blackPure, 0.4)}`,
      overflow: 'hidden',
    },
    cardHeader: {
      background: theme.palette.secondary.main,
      padding: SMALL_MARGIN,
    },
    cardUsers: {
      fontSize: 14,
      lineHeight: '18px',
      color: colorsPalette.violet,
      textAlign: 'center',
    },
    innerCard: {
      paddingTop: MIDDLE_MARGIN,
      paddingBottom: SMALL_MARGIN,
    },
    priceBlock: {
      padding: '0 10px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    price: {
      fontSize: 64,
      lineHeight: '48px',
      fontWeight: 800,
    },
    priceAttr: {
      fontWeight: 700,
      width: 36,
      fontSize: 16,
      lineHeight: '22px',
      textAlign: 'right',
      paddingRight: 10,
    },
    description: {
      color: colorsPalette.gray,
      textAlign: 'center',
      width: 210,
      padding: `0 ${MIDDLE_MARGIN}px`,
      margin: `24px auto 0`,
      lineHeight: 1.2,
    },
    changePlan: {
      marginTop: MIDDLE_MARGIN,
      fontWeight: 800,
      color: colorsPalette.blue,
      fontSize: 14,
      lineHeight: '18px',
    },
    btn: {
      marginTop: MIDDLE_MARGIN,
    },
    loaderTextWrapper: {
      marginTop: MIDDLE_MARGIN,
    },
  }),
);

export default useStyles;
